export default __webpack_public_path__ + "static/media/img-header-mkt-place.ac3128e4.png";